import React from 'react'
import { Box, Chip, Stack } from '@mui/material'

const StatusField = ({ value, type, statusList = [] }) => {
  const findStatusInfo = (code, objType) =>
    statusList.find((item) => item.status_code === code && item.object === objType) || {}

  const { status: label = value, color = 'default' } = findStatusInfo(value, type)

  return (
    <Stack spacing={1} alignItems='center'>
      <Box
        sx={{
          display: 'inline-block',
          backgroundColor: 'white',
          borderRadius: '16px',
          p: 0.1
        }}
      >
        <Chip
          label={label}
          variant='outlined'
          sx={{
            borderColor: color,
            color: color,
            backgroundColor: 'white',
            fontWeight: 600
          }}
        />
      </Box>
    </Stack>
  )
}

export default StatusField

export const buildStatusColumn = (type, statusList) => ({
  name: 'status',
  label: 'Statut',
  isFilter: true,
  valueEditorType: 'multiselect',
  values: statusList
    .filter((item) => item.object === type)
    .map(({ status_code, status: label }) => ({ name: String(status_code), label })),
  component: (value) => <StatusField value={value} type={type} statusList={statusList} />
})
